<template>
  <div id="app">
    <!-- Comprobamos el estado del store, si está identificado mostramos un template sino, el login -->
    <template v-if="loggedIn && !isTerms">
      <v-app id="inspire" class="app">
        <profile-view />
        <template v-if="!fullscreen">
          <app-drawer class="app--drawer" />
          <app-toolbar class="app--toolbar" />
        </template>
        <v-content>
          <!-- Page Header -->
          <template v-if="!fullscreen">
            <page-header v-if="$route.meta.breadcrumb" />
          </template>
          <div class="page-wrapper">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </div>
          <!-- App Footer -->
          <template v-if="!fullscreen">
            <v-footer height="auto" class="white pa-3 app--footer">
              <span class="caption"
                >Glospen SL &copy; {{ new Date().getFullYear() }}</span
              >
              <v-spacer />
              <TermsDialog @cookies="dialogCookies = true" />
            </v-footer>
          </template>
        </v-content>
        <!-- Go to top -->
        <app-fab />
        <!-- <v-navigation-drawer class="setting-drawer" temporary right false hide-overlay fixed></v-navigation-drawer> -->
        <v-snackbar v-model="isOffline" right :timeout="0" bottom color="error">
          {{ $t('error.error.notConnection') }}
        </v-snackbar>
      </v-app>
    </template>
    <template v-else>
      <transition name="page" mode="out-in">
        <router-view />
      </transition>
    </template>
    <cookies-manager />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ProfileView from './components/configuration/profile/ProfileView'
import AppDrawer from './components/ui/AppDrawer'
import AppFab from './components/ui/AppFab'
import AppToolbar from './components/ui/AppToolbar'
import PageHeader from './components/ui/PageHeader'
import TermsDialog from './components/widgets/Terms'
// import menu from './api/menu'
import CookiesManager from './components/widgets/cookies/CookiesManager'
import AppEvents from './event'
// import { apiAxios } from './helpers'
export default {
  name: 'App',
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    TermsDialog,
    ProfileView,
    CookiesManager,
  },
  data() {
    return {
      isOffline: false,
      dialogCookies: false,
    }
  },
  created() {
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback)
    })
    window.getApp = this

    const vm = this
    window.addEventListener('offline', function () {
      vm.isOffline = true
    })

    window.addEventListener('online', function () {
      vm.isOffline = false
    })
  },
  /* Store del estado del inicio de sesión */
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.user,
    }),
    isTerms() {
      const termsRoutes = ['terms-and-conditions', 'terms-of-use', 'cookies']
      return termsRoutes.includes(this.$route.name)
    },
    fullscreen() {
      return this.$route.meta.fullscreen === true
    },
  },
}
</script>

<style lang="scss">
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.page-enter {
  opacity: 0;
  transform: translateX(-30%);
}
.page-leave-to {
  opacity: 0;
  transform: translateX(30%);
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
